<template>
  <transition name="msgbox-fade">
    <div class="wf-tip" v-show="show">
      <p class="title">{{configComponents.title}}</p>
      <p class="content" @click="configComponents.contentClick($event)" v-html="configComponents.content"></p>
      <p class="footer">
        <wf-button @click="check">{{configComponents.confirm}}</wf-button>
      </p>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'WfTip',
  props: ['value', 'config'],
  data() {
    let _this = this
    return {
      show: false,
      check: _this.close,
      open: _this.openTip,
      configComponents: {
        title: '',
        content: '',
        confirm: '我知道了',
        contentClick: _this.contentClick
      }
    }
  },
  watch: {
    value: {
      handler() {
        if(this.value !== undefined) {
          this.show = this.value
          this.configComponents = Object.assign(this.configComponents, this.config)
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.show = false
      this.$emit('input', false)
      this.$emit('close')
    },
    contentClick(e) {
      this.$emit('contentClick', e)
    },
    openTip() {
      this.$emit('input', true)
      this.show = true
    }
  }
}
</script>
<style lang="scss">
.wf-tip {
  width: 370px;
  // height: 202px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  position: fixed;
  right: 24px;
  bottom: 40px;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px rgba(13,31,60,0.16);
  border-radius: 4px;
  border: 1px solid #EAEBEC;
  box-sizing: border-box;
  z-index: 100;
  .title {
    font-size: 18px;
    font-weight: 400;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    margin: 32px 0;
  }
  .footer {
    text-align: right;
  }
}
</style>
